const IMPLEMENT_TYPES = [
  { type: "TRUCK", shaftQuantity: 3, grossCapacity: 23.0, netCapacity: 16.0 },
  {
    type: "BITRUCK",
    shaftQuantity: 4,
    grossCapacity: 29.0,
    netCapacity: 19.0
  },
  { type: "TOCO", shaftQuantity: 5, grossCapacity: 41.5, netCapacity: 28.0 },
  {
    type: "ROMEU & JULIETA",
    shaftQuantity: 6,
    grossCapacity: 50.0,
    netCapacity: 32.5
  },
  {
    type: "LS (MENOR 16 MT)",
    shaftQuantity: 6,
    grossCapacity: 45.0,
    netCapacity: 31.0
  },
  {
    type: "LS (MAIOR 16 MT)",
    shaftQuantity: 6,
    grossCapacity: 48.5,
    netCapacity: 33.5
  },
  {
    type: "VANDERLEIA",
    shaftQuantity: 6,
    grossCapacity: 53.0,
    netCapacity: 36.0
  },
  {
    type: "BITREM 7 EIXOS",
    shaftQuantity: 7,
    grossCapacity: 57.0,
    netCapacity: 42.0
  },
  {
    type: "BITREM 8 EIXOS",
    shaftQuantity: 8,
    grossCapacity: 65.5,
    netCapacity: 46.5
  },
  {
    type: "RODOTREM 9 EIXOS",
    shaftQuantity: 9,
    grossCapacity: 74.0,
    netCapacity: 52.0
  },
  {
    type: "RODOTREM 11 EIXOS",
    shaftQuantity: 11,
    grossCapacity: 91.0,
    netCapacity: 65.6
  }
] as const;

export { IMPLEMENT_TYPES };
